import {
	allHighOrNoRatings,
	allHighRatings,
	allLowRatings,
	allNoRatings,
	formData,
	isHighRating,
	isLowRating,
	store,
} from 'src/feature-app';
import {
	addRemovedStep,
	getIndexInSteps,
	removeMultipleStepsAndResetScreenIndex,
	resetStepsScreenIndex,
} from 'src/forms/helpers';
import { Steps } from 'src/types';
import { stepNameToFieldName } from './data';

export const shuffleCEM = (array: number[]): number[] =>
	array.sort(() => Math.random() - 0.5);

export const getActionShowMotivoCEM = (
	nameOfMotivoStep: string,
	value?: string,
) => {
	if (value) {
		if (Number(value) == -1) value = 'Sin respuesta';
		if (isLowRating(value)) {
			return { action: 'add', steps: [nameOfMotivoStep] };
		} else {
			//} else if (isHighRating(value) || isNoRating(value)) {
			delete formData.fields[stepNameToFieldName(nameOfMotivoStep)];
			return { action: 'remove', steps: [nameOfMotivoStep] };
		}
	}
	return { action: 'none' };
};

/**
 * Se extrae la lógica para poder utilizarla por separado sin tener que usar las funciones de loading o updateSteps
 * ya que hay una pregunta en la que podemos eliminar y añadir un step en el mismo paso.
 * @param stepsToAdd
 * @param alternativeSteps
 * @returns
 */
export const addingStepsLogicCEM = (
	initialSteps: any[],
	stepsToAdd: string[],
	alternativeSteps?: Steps[],
) => {
	const { steps: actualSteps, screenIndex } = store.getState().formInfo;
	const stepsToUse = alternativeSteps ? alternativeSteps : actualSteps;
	// Hay que revertir los steps para que se añadan en el orden correcto
	const indexesInSteps = stepsToAdd
		.reverse()
		.map(step => getIndexInSteps(stepsToUse, step));
	let newSteps = [...stepsToUse];

	indexesInSteps.forEach((index, i) => {
		if (index === -1) {
			newSteps = addRemovedStep(
				initialSteps,
				stepsToUse,
				stepsToAdd[i],
				screenIndex,
			);
		}
	});
	const finalSteps = resetStepsScreenIndex(newSteps);
	return finalSteps;
};

/**
 * Se tiene que de manera consecutiva y no mediante las otras funciones porque si no, se actualizan los steps dos veces y en el segundo paso (añadir o eliminar el otro step) se hace siempre sobre los steps antiguos y no funciona de la manera esperada.
 *
 * @param stepToRemove
 * @param stepToAdd
 */
export const removeAndAddStepAtTheSameTimeCEM = (
	initialSteps: any[],
	stepToRemove: string,
	stepToAdd: string,
	dispatch: any,
	handleNextStep: () => void,
) => {
	const { steps } = store.getState().formInfo;
	const removedSteps = removeMultipleStepsAndResetScreenIndex(steps, [
		stepToRemove,
	]);
	const addedSteps = addingStepsLogicCEM(
		initialSteps,
		[stepToAdd],
		removedSteps,
	);
	const finalSteps = resetStepsScreenIndex(addedSteps);
	handleNextStep();
	updateStepsCEM(finalSteps, dispatch);
};

export const addStepsCEM = (
	initialSteps: any[],
	stepsToAdd: string[],
	dispatch: any,
	handleNextStep: () => void,
) => {
	const finalSteps = addingStepsLogicCEM(initialSteps, stepsToAdd);
	updateStepsCEM(finalSteps, dispatch);
	handleNextStep();
};

export const removeStepsCEM = (stepsToDelete: string[], dispatch: any) => {
	const { steps } = store.getState().formInfo;
	const finalSteps = removeMultipleStepsAndResetScreenIndex(
		steps,
		stepsToDelete,
	);
	updateStepsCEM(finalSteps, dispatch);
};

export const updateStepsCEM = (steps: Steps[], dispatch: any) => {
	dispatch({ type: 'UPDATE_STEPS', payload: steps });
	dispatch({
		type: 'UPDATE_LAST_STEP',
		payload: steps[steps.length - 1],
	});
	dispatch({ type: 'SET_NUMBER_OF_SCREENS', payload: steps.length });
};

export const lastQuestionFlow = (ratings: string[], lastQuestion: string) => {
	const goodRating = allHighRatings(ratings);
	const badRating = allLowRatings(ratings);
	const emptyRating = allNoRatings(ratings);
	const goodOrEmptyRating = allHighOrNoRatings(ratings);

	/* 
	Qfinal=4,5 AND NOT [Q1=3,2,1 AND Q2=3,2,1 AND Qn=3,2,1]
	OR
	Qfinal=3,2,1 AND Q1=5,4,9 AND Q2=5,4,9 AND Qn=5,4,9
	*/
	const mostrarQlast1 =
		(isHighRating(lastQuestion) && !badRating) ||
		(isLowRating(lastQuestion) && goodOrEmptyRating);

	/* 
	Qfinal=3,2,1 
	AND
	NOT [Q1=5,4,9 AND Q2=5,4,9 AND Qn=5,4,9]
	AND
	NOT [Q1=3,2,1 AND Q2=3,2,1 AND Qn=3,2,1]
	*/
	const mostrarQlast2 =
		isLowRating(lastQuestion) && !goodOrEmptyRating && !badRating;

	const urlParams = new URLSearchParams(window.location.search);
	const dev = urlParams.get('dev') !== null;

	if (dev) {
		console.log(
			'LAST RATING:',
			lastQuestion,
			'isHigh:',
			isHighRating(lastQuestion),
			'isLow:',
			isLowRating(lastQuestion),
		);
		console.log(
			'RATINGS:',
			ratings,
			'allgood:',
			goodRating,
			'allbad:',
			badRating,
			'allempty:',
			emptyRating,
			'allgoodroempty:',
			goodOrEmptyRating,
		);
		console.log('show1:', mostrarQlast1, 'show2:', mostrarQlast2);
	}

	return {
		mostrarQlast1: mostrarQlast1,
		mostrarQlast2: mostrarQlast2,
	};
};
